var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBubbles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.2,
    height: 19.1,
    viewBox: "0 0 23.2 19.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-bubbles"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_55",
    "data-name": "Capa 55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,8.3l-1.4-.8H15.9c-1.1,0-1.8-.6-1.8-1.5V4.4c0-.9.7-1.5,1.8-1.5h3.2c1.1,0,1.8.6,1.8,1.5V6a1.56,1.56,0,0,1-1.6,1.5v.4c0,.2-.1.3-.3.4A.45.45,0,0,1,18.5,8.3ZM14.6,4.4V6c0,.7.5,1.1,1.4,1.1h1.4l1.4.9h.1V7.4a.22.22,0,0,1,.2-.2c.8,0,1.4-.4,1.4-1.1V4.4c0-.7-.5-1.1-1.4-1.1H15.9A1.17,1.17,0,0,0,14.6,4.4Z",
    transform: "translate(-0.3 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_59",
    "data-name": "Capa 59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,8.4a.55.55,0,0,1-.3-.5V7.6A1.58,1.58,0,0,1,2.8,6V4.4c0-.9.7-1.5,1.8-1.5H7.8c1.1,0,1.8.6,1.8,1.5V6C9.7,7,9,7.6,7.9,7.6H6.6l-1.3.7A1.27,1.27,0,0,1,4.7,8.4ZM7.9,3.3H4.6c-.8,0-1.4.4-1.4,1.1V6c0,.7.5,1.1,1.4,1.1a.22.22,0,0,1,.2.2V8h.1l1.4-.8H7.7c.8,0,1.4-.4,1.4-1.1V4.4C9.2,3.8,8.7,3.3,7.9,3.3Z",
    transform: "translate(-0.3 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_56",
    "data-name": "Capa 56"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,12.8A3.1,3.1,0,1,1,18.1,16,3.08,3.08,0,0,1,15,12.8Zm.8,0a2.3,2.3,0,1,0,2.3-2.3A2.4,2.4,0,0,0,15.8,12.8Z",
    transform: "translate(-0.3 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4,20.9c0-1.9-1.9-3.4-4.3-3.4s-4.3,1.5-4.3,3.4a.4.4,0,1,1-.8,0c0-2.3,2.3-4.2,5.1-4.2s5.1,1.9,5.1,4.2a.4.4,0,1,1-.8,0Z",
    transform: "translate(-0.3 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_58",
    "data-name": "Capa 58"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,12.8a3.1,3.1,0,1,1,3.1,3.1A3.12,3.12,0,0,1,2.5,12.8Zm.8,0a2.26,2.26,0,0,0,2.3,2.3,2.3,2.3,0,0,0,0-4.6A2.26,2.26,0,0,0,3.3,12.8Z",
    transform: "translate(-0.3 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,20.8c0-1.8-1.9-3.3-4.2-3.3S1.4,19,1.4,20.8a.43.43,0,0,1-.4.4.43.43,0,0,1-.4-.4c0-2.3,2.2-4.2,5-4.2s5,1.9,5,4.2a.43.43,0,0,1-.4.4A.37.37,0,0,1,9.8,20.8Z",
    transform: "translate(-0.3 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-0.3 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-0.3 -2.5)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbles);
export default __webpack_public_path__ + "static/media/chat-bubbles.5fb717e6674951e909046c7f6385d4ad.svg";
export { ForwardRef as ReactComponent };